<template>
  <div>
    <div class="outerBox" :style="{ backgroundImage: 'url(' + imgPath + ')' }">
      <div class="register" @click="register">
        <div>立即注册</div>
        <img src="@/assets/image/jiantou2.png" alt="" />
      </div>
    </div>
    <van-popup v-model="registerBox" position="bottom" round style="height:88%;">
      <div class="popup_content">
        <input type="number" class="popup_input" placeholder="请输入手机号"
          placeholder-style="color:#888888;font-weight: 400 !important;" v-model="mobile" />
        <div class="obtain">
          <div class="obtainOne">获取验证码</div>
          <div class="obtainTwo" @click="obtainClick"> {{ obtain == 0 ? "获取" : obtain }} </div>
          <van-count-down ref="countDown" :time="60 * 1000" format="ss" :autoStart="false" @change="onChange"
            v-show="false">
          </van-count-down>
        </div>
        <div class="verification">
          <van-password-input :value="passwordCode" :gutter="10" :focused="showKeyboard" @focus="showKeyboard = true" />
          <van-number-keyboard v-model="passwordCode" :show="showKeyboard" @blur="showKeyboard = false" />
        </div>
        <input type="text" class="popup_input" placeholder="请设置登录密码"
          placeholder-style="color:#888888;font-weight: 400 !important;" v-model="password" />
        <input type="text" class="popup_input" placeholder="请确认登录密码"
          placeholder-style="color:#888888;font-weight: 400 !important;" v-model="repassword" />
        <input type="text" class="popup_input" placeholder="填写邀请码（非必填）"
          placeholder-style="color:#888888;font-weight: 400 !important;" v-model="invitecode" />
        <div class="register registerTwo" @click="logon" v-throttle>
          <div>注册并下载</div>
          <img src="@/assets/image/jiantou2.png" alt="" />
        </div>
      </div>
    </van-popup>
    <van-popup v-model="receiveBox" position="bottom" round style="height:66%;">
      <div class="receive_content">
        <div class="receive_1">恭喜您获得{{ list == "" ? '' : list[0].dis_name }}专属优惠券</div>
        <div class="listItem">
          <div class="itemCont" v-for="(item, index) in list" :key="index">
            <img src="@/assets/image/yhjsajqb.png" alt="" class="yhjsajqb">
            <div>
              <div class="itemLeft isUseTwo">
                <div class="couponPrice isUseTwo" v-if="item.coupon_type_id != 2">
                  <div>￥</div> {{ item.price }}
                </div>
                <div class="couponPrice couponPrice_2 isUseTwo" v-if="item.coupon_type_id == 2"> {{ item.discount }}
                  <div>折 </div>
                </div>
              </div>
              <div class="itemRight">
                <div class="rightOne">
                  <div class="rightTip isUseTwo">满{{ item.doorsill }}元使用</div>
                </div>
                <div class="rightTwo isUseTwo">{{ item.use_begin_time }}~{{ item.use_end_time }}</div>
              </div>
            </div>
          </div>
        </div>
        <div style="height:72px;width:100%;"></div>
        <div class="receive_3">
          <div class="register" @click="receive">
            <div>领取并下载APP</div>
            <img src="@/assets/image/jiantou2.png" alt="" />
          </div>
        </div>
      </div>
    </van-popup>
    <download :isDown="isDown" @mongolia="downLoad"></download>
    <dialogView ref="myDialog" @userBehavior="downLoad"></dialogView>
  </div>
</template>
<script>
/**
 * Created by www.xingnuocn.com
 * @title：邀请用户下载
 *
 * @author: 刘嘉鑫
 * @version  V1.0
 * @datecreate: 2022-05-11 14:03
 */

export default {
  data() {
    return {
      isDown: false, // 下载弹框
      imgPath: require("@/assets/image/yaoqingyonghu.png"),

      registerBox: false, // 注册弹框

      obtain: "获取",
      time: 60,

      timeData: {},

      mobile: "", // 手机号

      passwordCode: "",
      showKeyboard: false,

      password: "", // 密码
      repassword: "", // 二次密码
      invitecode: "", // 邀请码

      user_id: "", // 邀请者id
      type: "", //

      isWeiXin: false,

      receiveBox: false, // 领取优惠券
      list: "",
    };
  },
  mounted() {
    this.user_id = this.$route.query.user_id; //用户id
    this.type = this.$route.query.type; // 邀请类型
    this.invitecode = this.$route.query.invitecode; //邀请码
    console.log(this.$client);
    this.$axios({
      url: `${this.$root.baseUrlTwo} `,
      data: this.$qs.stringify({
        invitecode: this.invitecode,
        invite_user_id: this.user_id
      }),
      method: "post",
      headers: {
        // "Content-Type": "application/json;charset=UTF-8",
        'Content-Type': 'application/x-www-form-urlencoded;',
      }, // 请求头
    }).then((result) => {
      console.log("用户扫码", result);
    });
    if (
      this.$client.QQ == true &&
      this.$client.QQBROWSER == true &&
      this.$client.WEIXIN != true
    ) {
      if (this.$client.ANDROID == true) {
        try {
          window.location.href =
            "http://qny.ttsmapp.xingnuo.vip/uploads/20220510/536da2afe80be46f30d5911c72ca15f9.apk";
          setTimeout(function () {
            window.location.href =
              "http://qny.ttsmapp.xingnuo.vip/uploads/20220510/536da2afe80be46f30d5911c72ca15f9.apk";
          }, 500);
          console.log("安卓");
        } catch (e) { }
      }
    }

    document.title = "下载注册"; // 邀请好友

    // this.getCoupon()
  },
  methods: {
    /**
     * Created by www.xingnuocn.com
     * @title：注册
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2022-05-11 15:22
     */
    register() {
      this.registerBox = true;
    },

    /**
     * 倒计时
     * 刘嘉鑫
     * 2022-5-11
     */
    onChange(e) {
      this.timeData = e;
      this.obtain = e.seconds;
    },

    /**
     * 获取验证码
     * 刘嘉鑫
     * 2022-5-11
     */
    obtainClick() {
      let that = this;
      if (this.mobile == "") {
        this.$toast("请输入手机号");
        return;
      } else if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        this.$toast("手机号不正确");
        return;
      } else {
        this.$axios({
          method: "post",
          headers: {
            "Content-Type": "application/json",
            // "Content-Type": "application/x-www-form-urlencoded",
          }, // 请求头
          url: `${this.$root.baseUrlTwo}/Sms/d938b0a`, // /sms/send
          data: {
            mobile: this.mobile,
            event: "register",
          },
        }).then((result) => {
          console.log("验证码", result);
          if (result.data.code == 1) {
            this.$toast(result.data.msg);
            that.$refs.countDown.start();
          } else if (result.data.code == 2) {
            that.registerBox = false;
            that.$refs.myDialog.show("您的手机号已被注册，请直接下载", {
              type: "alert",
              confirmText: "下载",
              cancelText: "取消",
              titleText: "",
              data: null,
            });
          } else {
            this.$toast(result.data.msg);
          }
        });
      }
    },

    /**
     * 注册并下载
     * 刘嘉鑫
     * 2022-5-11
     */
    logon() {
      let that = this;



      // if (this.mobile == "") {
      //   this.$toast("请输入手机号");
      //   return;
      // } else if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
      //   this.$toast("手机号不正确");
      //   return;
      // } else if (this.passwordCode == "") {
      //   this.$toast("请获取验证码");
      //   return;
      // } else if (this.password == "") {
      //   this.$toast("请输入登录密码");
      //   return;
      // } else if (this.repassword == "") {
      //   this.$toast("请再次输入密码");
      //   return;
      // } else if (this.repassword != this.password) {
      //   this.$toast("两次密码不一致");
      //   return;
      // } else {
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
        url: `${this.$root.baseUrlTwo}/login/register`,
        data: {
          mobile: this.mobile,
          password: this.password,
          repassword: this.repassword,
          code: this.passwordCode,
          invitecode: this.invitecode,
          invite_user_id: this.user_id,
          type: this.type,
        },
      }).then((result) => {
        console.log("注册", result);
        if (result.data.code == 1) {
          that.$toast(result.data.msg);
          that.registerBox = false;
          // that.downLoad();
          that.getCoupon(result.data.data)
        } else if (result.data.code == 2) {
          that.$toast("手机号已注册");
          that.registerBox = false;
          that.downLoad();
        } else {
          that.$toast(result.data.msg); z
        }
      });
      // }
    },

    /**
     * Created by www.xingnuocn.com
     * @title：下载
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2022-05-11 15:22
     */
    downLoad() {
      console.log("下载app");
      if (
        (this.$client.QQ == true && this.$client.QQBROWSER == false) ||
        this.$client.WEIXIN == true
      ) {
        this.isDown = !this.isDown;
        return;
      } else {
        if (this.$client.ANDROID == true) {
          try {
            window.location.href =
              "http://qny.ttsmapp.xingnuo.vip/uploads/20220510/536da2afe80be46f30d5911c72ca15f9.apk";
            setTimeout(function () {
              window.location.href =
                "http://qny.ttsmapp.xingnuo.vip/uploads/20220510/536da2afe80be46f30d5911c72ca15f9.apk";
            }, 500);
            console.log("安卓");
          } catch (e) { }
        } else if (this.$client.IPHONE == true) {
          try {
            window.location.href =
              "https://apps.apple.com/cn/app/首摩到家-优质上门按摩平台/id1625851385";
            console.log("ios");
            return;
          } catch (e) { }
        }
      }
    },

    /**
     * Created by www.xingnuocn.com
     * @title：关闭蒙层
     *
     * @author: 刘嘉鑫
     * @version  V1.0
     * @datecreate: 2021-06-25 16:10
     */
    mongolia() {
      this.isShow = false;
    },

    /**
    * 优惠券信息
    * 刘嘉鑫
    * 2024-2-2
    */
    getCoupon(info) {
      this.$axios({
        url: `${this.$root.baseUrlTwo}/index/distributionCoupon`,
        data: {
          token: info.token
          // token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJYSU5HTlVPIiwiYXVkIjoidHRzbSIsInVzZXJfaWQiOjEsInV1aWRfdGltZSI6MTY5Nzg1OTEyNH0.usvL1OKyF5eoM-A1pArgcytCJKWNl6NTJ1eVNUVwWiY"
        },
        method: "post",
        headers: {
          "Content-Type": "application/json",
          // "Content-Type": "application/x-www-form-urlencoded",
        }, // 请求头
      }).then((result) => {
        if (result.data.data.list.length <= 0) {
          this.downLoad();
        } else {
          this.list = result.data.data.list;
          this.receiveBox = true
        }
      });
    },

    /**
     * 领取并下载App
     * 刘嘉鑫
     * 2024-2-2
     */
    receive() {
      this.downLoad();
      this.receiveBox = false
      setTimeout(() => {
        this.list = ""
      }, 200);
    },
  },
};
</script>
<style>
.van-password-input__security {
  height: 80px;
}

.van-password-input__item {
  width: 80px;
  height: 100px;
  border: 4px solid #e2e2e2;
  border-radius: 16px;
}

.van-key {
  height: 80px;
}

.van-toast {
  width: 30%;
  height: 6%;
  font-size: 28px;
}
</style>
<style lang='scss' scoped>
.outerBox {
  // background: url("~@/assets/image/yaoqingyonghu.png");
  width: 100%;
  height: 100%;
  position: fixed;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
}

.register {
  padding: 20px 130px 22px;
  background: linear-gradient(180deg, #ffffff 10%, #44979d 90%);
  box-shadow: 1px 14px 15px 0px rgba(0, 0, 0, 0.18);
  border-radius: 55px;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 100px;

  >div {
    font-size: 44px;
    font-family: FZZhengHeiS-EB-GB;
    font-weight: 400;
    color: #b21d1f;
    margin-right: 20px;
  }

  >img {
    width: 45px;
    height: 44px;
  }
}

.registerTwo {
  position: relative !important;
  margin-top: 100px;
  padding: 22px 0 24px;
  width: 100%;
  justify-content: center;
  background: linear-gradient(180deg, rgba(68, 151, 157, 0.7) 0%, #44979d 100%);
  box-shadow: 1px 14px 15px 0px rgba(0, 0, 0, 0.18);
}

.popup_content {
  padding: 80px 95px 0;

  .popup_input {
    padding: 26px 16px;
    text-align: center;
    font-size: 32px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #222222;
    border: 4px solid #e2e2e2;
    border-radius: 24px;
    width: 93%;
    margin-bottom: 40px;
  }

  .obtain {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;

    .obtainOne {
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #222222;
    }

    .obtainTwo {
      background: #44979d;
      border-radius: 12px;
      padding: 14px 32px;
      font-size: 28px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffffff;
    }
  }

  .verification {
    margin-bottom: 40px;
  }
}

.receive_content {
  padding: 80px 0 0;
  position: relative;

  .receive_1 {
    font-size: 36px;
    font-weight: 500;
    color: #222222;
    text-align: center;
    margin-bottom: 30px;
  }

  .listItem {
    position: relative;
    padding: 0 45px;

    .itemCont {
      padding: 30px 34px 30px 0;
      position: relative;
      margin-bottom: 20px;

      .yhjsajqb {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        display: block;
        width: 100%;
        height: 100%;
        z-index: 1;
      }

      >div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        z-index: 100;

        .isUseTwo {
          color: #ffffff !important;
        }

        .isUseThree {
          background: #D2D2D2 !important;
          padding: 10px !important;
        }

        .itemLeft {
          width: 34%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;

          .couponPrice {
            font-size: 44px;
            font-weight: bold;
            color: #ffffff;
            display: flex;
            align-items: center;

            div {
              font-size: 30px;
            }
          }

          .couponPrice_2 {
            div {
              font-size: 26px;
            }
          }

          .couponType {
            font-size: 24px;
            font-weight: bold;
            color: #ffffff;
          }
        }

        .itemRight {
          width: 60%;
          display: flex;
          justify-content: space-between;
          flex-direction: column;

          .rightOne {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .rightTip {
              font-size: 28px;
              font-weight: 400;
              color: #222222;
            }

            .use {
              background: #00C3A1;
              border-radius: 12px;
              padding: 10px 20px;
              font-size: 26px;
              font-weight: bold;
              color: #FFFFFF;
            }
          }

          .rightTwo {
            font-size: 24px;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }

    .outerBot {
      padding: 40px 34px 20px;
      background: #EAEAEA;
      border-radius: 0 0 16px 16px;
      margin-top: -20px;

      .expire {
        font-size: 26px;
        font-weight: 400;
        color: #444444;
      }
    }
  }

  .receive_3 {
    background: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px 0;
    z-index: 999;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .register {
    padding: 20px 0 22px;
    width: 80%;
    justify-content: center;
    position: static;
  }
}
</style>
